const config = {
  AUTH_WHITE_LIST: ['18815158532', '19941235718', '13738395200'],
  // 预约日期范围 默认一个月
  SIGN_DATE_RANGE: 30,
  // 预约日期开始offset 默认后天
  SIGN_DATE_START_OFFSET: 2,
  // 预约日期结束offset 默认2周
  SIGN_DATE_END_OFFSET: 21,
  // 图片只因路由
  BASE_URL: process.env.NODE_ENV === 'production' ? 'https://ratshyh.wzgo.cn' : 'http://localhost:8080/',
  // 订票数限制
  SIGN_NUM_LIMIT: {
    // 个人限制
    SINGLE_SIGN_MIN_NUM: 1,
    SINGLE_SIGN_MAX_NUM: 7,
    // 团队人数
    TEAM_SIGN_NUM: 8
  },
  // 埋点参数
  TRACKER: {
    APP_ID: '2023112104'
  }
};
export default config;
